import "../phaser.min.js";
import Common from "../Includes/Common.js";

class GameLost extends Phaser.Scene {

    constructor() {
        super('GameLost');
        this.common = new Common();
        this.pausedScenes = [];
    }

    init(data){
        this.player = data.player;
    }

    preload() {

    }

    create() {

        this.sirenSFX = this.sound.add('siren', {volume: this.common.blipVolume});
        this.sirenSFX.play({
            delay: 0,
            detune: -500,
        });
        this.tweens.add({
            targets: this.sirenSFX,
            volume: 0,
            delay: 1800,
            duration: 500
        })

        this.loseSFX = this.sound.add('lose', {volume: this.common.bgMusicVolume});
        this.loseSFX.play({
            delay: 2.3
        });

        this.pauseActiveScenes()

        this.modalOverlay = this.add.rectangle(0, 0, this.scale.width, this.scale.height, '#555553')
                .setScale(this.common.gameScale)
                .setAlpha(0.8)

        this.modal = this.add.image(0, 0, 'ui', 'dropdown-flat')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale);

        this.modalHeading = this.add.text(
                this.scale.width / 2,
                this.scale.height / 12 * 2.5,
                'Slow Down!',
                {
                    fontFamily: this.common.font, fontSize: 96, color: '#333',
                    textAlign: 'center',
                    wordWrap: {
                        width: this.modal.width * 4 - 800,
                        useAdvancedWrap: true,
                    }
                }).setOrigin(0.5)
        this.modalTextLine1 = this.add.text(
                this.scale.width / 2,
                this.scale.height / 12 * 6.75,
                "It seems that you have gotten too many wrong...",
                {
                    fontFamily: this.common.font, fontSize: 60, color: '#333',
                    textAlign: 'center',
                    wordWrap: {
                        width: this.modal.width * 4 - 800,
                        useAdvancedWrap: true,
                    }
                }).setOrigin(0.5)

        this.modalTextLine2 = this.add.text(
                this.scale.width / 2,
                this.scale.height / 12 * 7.5,
                "Slow down and try again!",
                {
                    fontFamily: this.common.font, fontSize: 60, color: '#333',
                    textAlign: 'center',
                    wordWrap: {
                        width: this.modal.width * 4 - 800,
                        useAdvancedWrap: true,
                    }
                }).setOrigin(0.5)

        this.road = this.add.tileSprite(this.scale.width / 2, this.scale.height / 12 * 5.3, 250, 18, 'level', 'road1').setScale(6)
        this.copcar = this.add.sprite(0, this.scale.height / 12 * 4.5, 'cop-car', 0)
                .setScale(6)
        this.tweens.add({
            targets: this.copcar,
            x: this.scale.width / 2,
            duration: 1500,
        })

        if(!this.anims.exists('cop-car')) {
            this.anims.create({
                key: 'cop-car',
                frames: this.anims.generateFrameNames('cop-car', {
                    prefix: 'cop-car ',
                    start: 0,
                    end: 4,
                    zeroPad: 0,
                    suffix: '.aseprite'
                }),
                frameRate: 5,
                repeat: -1
            })
        }
        this.copcar.play('cop-car');

        this.buttonContainer = this.add.container(this.scale.width / 2, this.scale.height / 12 * 9.5);
        this.button = this.add.sprite(0, 0, 'ui', 'start-lg-normal' ).setScale(this.common.gameScale).setOrigin(0.5)
        this.buttonText = this.add.text(-10, -5, 'Try Again', {fontFamily: this.common.font, fontSize: 48, color: this.common.blue}).setOrigin(0.5)
        this.buttonContainer.add([this.button, this.buttonText])
        this.button.setInteractive({cursor: 'pointer'})
        this.button.on('pointerdown', function(e) {
            // this.pausedScenes.forEach(scene => {
            //     if (scene && scene.scene && scene.scene.key !== this.scene.key) {
            //         scene.scene.resume();
            //     }
            // });
            // this.scene.stop(this)

            //window.location.href = window.location.pathname + '?district=' + this.player.district;

            window.location.reload();
        }, this)
        this.button.on('pointerover', function(e) {
            this.button.setTexture('ui', 'start-lg-hover')
            this.tweens.add({
                targets: this.button,
                scale: 4.2,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        }, this)
        this.button.on('pointerout', function(e) {
            this.button.setTexture('ui', 'start-lg-normal')
            this.tweens.add({
                targets: this.button,
                scale: 4,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        }, this)
    }

    update() {
        this.road.tilePositionX += 0.5;
    }

    pauseActiveScenes() {
        this.pausedScenes = [];
        let activeScenes = this.scene.manager.getScenes(true);
        activeScenes.forEach(scene => {
            // Prevent the current scene from pausing itself
            if (scene && scene.scene && scene.scene.key !== this.scene.key) {
                this.pausedScenes.push(scene);
                scene.scene.pause();
            }
        });
    }

}
export default GameLost;